module.exports = __webpack_public_path__ + "img/launching-tips.c7fcd127.png";